export const LocalStorageToken = 'authToken';
export const SnackbarDurationMilliseconds: number = 4000;

export const WeekdayNames: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
